import { useQuery } from '@tanstack/react-query';
import { ImageOff } from 'lucide-react';
import { rawFetch } from '../api/client';
import { cn } from '../lib/cn';

/**
 * Bild aus der API laden (mit Anmeldung) und als Object-URL anzeigen.
 * Nötig, weil <img src> keinen Authorization-Header mitschicken kann.
 */
export function AuthImage({ src, alt, className }: { src: string; alt: string; className?: string }) {
  const q = useQuery({
    queryKey: ['blob', src],
    queryFn: async () => URL.createObjectURL(await (await rawFetch(src)).blob()),
    staleTime: Infinity,
    gcTime: 5 * 60_000,
  });
  if (q.isPending) return <div className={cn('animate-pulse bg-slate-100', className)} />;
  if (q.error || !q.data)
    return (
      <div className={cn('flex items-center justify-center bg-slate-100 text-slate-400', className)}>
        <ImageOff className="size-6" />
      </div>
    );
  return <img src={q.data} alt={alt} className={cn('object-cover', className)} />;
}
